var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 375 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.203 5.203h364.594v364.594H5.203Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 5.203C86.82 5.203 5.203 86.82 5.203 187.5S86.82 369.797 187.5 369.797 369.797 288.18 369.797 187.5 288.18 5.203 187.5 5.203m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.203.203h364.594v364.594H.203Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.5.203C81.82.203.203 81.82.203 182.5S81.82 364.797 182.5 364.797 364.797 283.18 364.797 182.5 283.18.203 182.5.203m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h365v365H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.336 118.246h194.25v138.75H90.336Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M.203.203h364.594v364.594H.203Zm0 0"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M267.727 118.246H107.262c-9.282 0-16.852 7.547-16.852 16.852v104.8c0 9.282 7.55 16.852 16.852 16.852h160.465c9.28 0 16.851-7.55 16.851-16.852v-104.8c0-9.286-7.55-16.852-16.851-16.852m7.996 121.652c0 4.399-3.578 7.997-7.996 7.997H107.262a7.994 7.994 0 0 1-7.996-7.997v-104.8c0-4.418 3.578-8 7.996-8h160.465a7.997 7.997 0 0 1 7.996 8Zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M257.883 156.05h-56.91a4.414 4.414 0 0 0-4.418 4.419 4.416 4.416 0 0 0 4.418 4.418h56.91a4.416 4.416 0 0 0 4.418-4.418 4.414 4.414 0 0 0-4.418-4.418M257.883 183.32h-56.91a4.416 4.416 0 0 0-4.418 4.418 4.416 4.416 0 0 0 4.418 4.418h56.91a4.416 4.416 0 0 0 4.418-4.418 4.416 4.416 0 0 0-4.418-4.418M257.883 210.594h-56.91a4.416 4.416 0 0 0-4.418 4.418 4.416 4.416 0 0 0 4.418 4.418h56.91a4.416 4.416 0 0 0 4.418-4.418 4.416 4.416 0 0 0-4.418-4.418M174.39 192.793l-10.609-5.016a41 41 0 0 0-4.25-1.714 17.7 17.7 0 0 0 5.426-12.77v-6.395c0-9.73-7.848-17.671-17.504-17.671s-17.504 7.921-17.504 17.671v6.395c0 5.016 2.086 9.543 5.426 12.77a36 36 0 0 0-4.25 1.714l-10.61 5.016c-4.902 2.309-8.07 7.344-8.07 12.805v6.785c0 7.793 6.301 14.148 14.02 14.148h41.976c7.739 0 14.02-6.336 14.02-14.148v-6.785c0-5.461-3.168-10.496-8.07-12.805m-37.042-25.895c0-5.609 4.53-10.18 10.086-10.18 5.554 0 10.086 4.571 10.086 10.18v6.395c0 5.61-4.532 10.176-10.086 10.176s-10.086-4.567-10.086-10.176Zm37.71 45.485h-.015c0 3.672-2.965 6.656-6.602 6.656h-41.996c-3.636 0-6.601-2.984-6.601-6.656v-6.785a6.7 6.7 0 0 1 3.804-6.04l10.606-5.015c4.195-1.977 8.687-2.98 13.2-2.98 4.491 0 9.003.984 13.198 2.98l10.606 5.016c2.312 1.097 3.8 3.464 3.8 6.039Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralDetails);
export default __webpack_public_path__ + "static/media/GeneralDetails.17cf1a3e37a1d32a897b53973693a051.svg";
export { ForwardRef as ReactComponent };